module.exports = __webpack_public_path__ + "img/feeding.76b56b62.png";